// material-ui

// project import
import MainCard from '../../../../components/MainCard';


// ==============================|| DRAWER CONTENT - NAVIGATION CARD ||============================== //

const NavCard = () => (
  <MainCard sx={{ bgcolor: 'grey.50', m: 3, visibility: 'hidden' }}>
    
  </MainCard>
);

export default NavCard;
